export default [
  {
    path: "/social",
    meta: { navbarTitle: "Social", hideAppBar: true, fullWidth: true },
    name: "Social",
    component: () => import(/* webpackChunkName: "social" */ "@/views/social/SocialHub.vue"),
  },
  {
    path: "/social/admin-approval",
    meta: { navbarTitle: "Admin", hideAppBar: true, fullWidth: true },
    name: "SocialAdminApproval",
    component: () => import(/* webpackChunkName: "social" */ "@/views/social/AdminApproval.vue"),
  },
]
